import React from 'react';

/**
 * <BrandLogo /> — CRATELAB wordmark lockup.
 *
 * Layout: blue isometric box icon + "CRATEL" (dark slate) + "AB" (lighter
 * blue) rendered in the Nasalization typeface.
 *
 * Sizes:
 *   - sm : 24px icon · 14px text (compact contexts, footers)
 *   - md : 32px icon · 18px text (top navs, sidebars)
 *   - lg : 48px icon · 28px text (marketing hero)
 *
 * The font is registered in /app/frontend/src/index.css via @font-face.
 * The icon PNG lives at /public/cratelab-box-icon.png.
 */
const SIZES = {
  sm: { icon: 'w-10 h-10', text: 'text-[14px]', gap: 'gap-2',   tracking: 'tracking-[0.03em]' },
  md: { icon: 'w-16 h-16', text: 'text-[20px]', gap: 'gap-3',   tracking: 'tracking-[0.03em]' },
  lg: { icon: 'w-24 h-24', text: 'text-[36px]', gap: 'gap-4',   tracking: 'tracking-[0.02em]' },
};

export default function BrandLogo({ size = 'md', className = '', iconOnly = false, stack = false, ...rest }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span
      className={`inline-flex items-center select-none ${stack ? 'flex-col gap-1.5' : s.gap} ${className}`}
      {...rest}
    >
      <img
        src="/cratelab-box-icon.png"
        alt=""
        aria-hidden="true"
        draggable={false}
        className={`${s.icon} object-contain shrink-0`}
      />
      {!iconOnly && (
        <span
          className={`brand-wordmark leading-none ${s.text} ${s.tracking}`}
          aria-label="CRATELAB"
        >
          <span className="text-[#0F172A]">CRATEL</span>
          <span className="text-[#3B82F6]">AB</span>
        </span>
      )}
    </span>
  );
}
